import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const Loading = () => {
  return (
    <Box justifyContent="center" alignItems="center" paddingY="s96" gap="s12">
      <Spinner />
      <Box gap="s4" justifyContent="center" alignItems="center">
        <Text.Normal weight="medium" size="300" color="grey1000">
          {i18n.t('finance.financial_workspace.breakdown_table.loading.title')}
        </Text.Normal>
        <Text.Normal size="200" color="textSecondary">
          {i18n.t('finance.financial_workspace.breakdown_table.loading.description')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
